import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import DashImportacaoModel from "../classes/DashImportacao";
import DashImportacaoHeaderModel from "../classes/DashImportacaoHeader";
interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "DashboardImportacao" },
];

const cacheKey: string = "DashImportacao";
const cacheKeySelC: string = "DashImportacaoSelecionado";

const apiServico: string = "DASHBOARD";

export default class DashImportDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(
    dataInicio: Date,
    dataFim: Date,
    parceiros: number[]
  ): Promise<DashImportacaoHeaderModel> {
    let ok: boolean = false;
    let data: DashImportacaoHeaderModel;
    let error: any = undefined;

    let params = `dataInicial=${dataInicio.toDateString()}&dataFinal=${dataFim.toDateString()}`;
    parceiros.forEach(x=> params += `&codigoFornecedorSap=${x}`);
    
    await super
    .Get( `${calls[0].rota}?${params}`)
      .then((response: AxiosResponse) => {
        ok = response.status === 200;
        data = response.data;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<DashImportacaoHeaderModel>((resolve) => {
      resolve(data);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): DashImportacaoModel[] {
    let result: DashImportacaoModel[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: DashImportacaoModel[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
